<div class="container">
    <div class="content">
        <img [src]="icon" alt=""/>
        <h4>{{title}}</h4>
        <p>{{text}}</p>
    </div>
   <!-- <a [routerLink]="url" class="primary-btn-arrow">{{linkName}}</a>-->
</div>
